const React = require('react');
const css = require('./module.scss');

var SurveyButton = React.createClass({
    getInitialState: function() {
        return {
            x: null,
            y: null,
            dragging: false
        };
    },

    componentDidMount: function() {
        var self = this;
        var el = this.refs.surveyButton;
        var startX, startY, origX, origY;
        var hasMoved = false;

        el.addEventListener('mousedown', function(e) {
            e.preventDefault();
            hasMoved = false;
            startX = e.clientX;
            startY = e.clientY;

            var rect = el.getBoundingClientRect();
            origX = rect.left;
            origY = rect.top;

            self.setState({ dragging: true });

            function onMouseMove(e) {
                var dx = e.clientX - startX;
                var dy = e.clientY - startY;
                if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
                    hasMoved = true;
                }
                var newX = origX + dx;
                var newY = origY + dy;
                // 边界限制
                var maxX = window.innerWidth - el.offsetWidth;
                var maxY = window.innerHeight - el.offsetHeight;
                newX = Math.max(0, Math.min(newX, maxX));
                newY = Math.max(0, Math.min(newY, maxY));
                self.setState({ x: newX, y: newY });
            }

            function onMouseUp() {
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('mouseup', onMouseUp);
                self.setState({ dragging: false });
            }

            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', onMouseUp);
        });

        // 触摸事件支持
        el.addEventListener('touchstart', function(e) {
            hasMoved = false;
            var touch = e.touches[0];
            startX = touch.clientX;
            startY = touch.clientY;

            var rect = el.getBoundingClientRect();
            origX = rect.left;
            origY = rect.top;

            self.setState({ dragging: true });

            function onTouchMove(e) {
                var touch = e.touches[0];
                var dx = touch.clientX - startX;
                var dy = touch.clientY - startY;
                if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
                    hasMoved = true;
                }
                var newX = origX + dx;
                var newY = origY + dy;
                var maxX = window.innerWidth - el.offsetWidth;
                var maxY = window.innerHeight - el.offsetHeight;
                newX = Math.max(0, Math.min(newX, maxX));
                newY = Math.max(0, Math.min(newY, maxY));
                self.setState({ x: newX, y: newY });
            }

            function onTouchEnd() {
                document.removeEventListener('touchmove', onTouchMove);
                document.removeEventListener('touchend', onTouchEnd);
                self.setState({ dragging: false });
            }

            document.addEventListener('touchmove', onTouchMove);
            document.addEventListener('touchend', onTouchEnd);
        });

        el.addEventListener('click', function(e) {
            if (hasMoved) {
                e.stopPropagation();
                e.preventDefault();
            }
        }, true);
    },

    handleClick: function(e) {
        if (this.state.dragging) return;
        if (this.props.onClick) {
            this.props.onClick();
        }
    },

    render: function() {
        var style = {};
        if (this.state.x !== null && this.state.y !== null) {
            style.left = this.state.x + 'px';
            style.top = this.state.y + 'px';
        }
        return (
            <div ref="surveyButton" className="fp-survey-entry" style={style} onClick={this.handleClick}>
                 <img className="fp-survey-entry-inner fp-survey-icon" src={require('./images/survey-icon.png')} alt="问卷调查" />
                 <div className="fp-survey-text">问卷调查</div>
            </div>
        );
    }
});

module.exports = SurveyButton;


// WEBPACK FOOTER //
// ./component/surveyButton/index.js